import React, { useState } from "react";

import { useOpenDialog  } from "../../context/DialogContext";

import {formatPhoneNumber} from '../../utils'
import {useHouseholds} from '../../apis'
import { matchesHouseholdSearch } from '../../utils/householdData'

import {
    Grid
} from "@material-ui/core";
import MUIDataTable from "../../components/DataTable"
import AddToolButton from "../../components/DataTable/AddToolButton"
import { Button } from "../../components/Wrappers";
import UpsertForm from "./UpsertForm";
import MergeHouseholdsForm from "./MergeHouseholdsForm";
import {useHelperStyles} from '../../styles'


const Households = ({history}) => {       
    const openDialog = useOpenDialog()
    const helperClasses = useHelperStyles()
    const [columnFilterState, setColumnFilterState] = useState({ filterList: [], resultCount: null })
    const [selectedHouseholds, setSelectedHouseholds] = useState([])
    
    const openHousehold = (household) => {
        history.push('/app/household/'+household.id)
    }
    const openCreateHousehold = (prefill = {}) => {
        openDialog("Create New Household", <UpsertForm history={history} prefill={prefill} />)
    }
    const openMergeHouseholds = () => {
        if (selectedHouseholds.length !== 2) return
        openDialog(
          "Merge Households",
          <MergeHouseholdsForm
            mainHousehold={selectedHouseholds[0]}
            mergeHousehold={selectedHouseholds[1]}
            history={history}
          />,
          { dialogProps: { maxWidth: "md", fullWidth: true } },
        )
    }
    const {households,isError,isLoading} = useHouseholds()
    const getSingleFilterValue = (columnIndex) => {
        const filterValues = columnFilterState.filterList[columnIndex] || []
        return filterValues.length === 1 ? filterValues[0] : ""
    }
    const hasActiveColumnFilter = columnFilterState.filterList.some(filterValues => filterValues.length > 0)
    const showFilteredCreateButton = hasActiveColumnFilter && columnFilterState.resultCount !== null && columnFilterState.resultCount < 10
    const filterPrefill = {
        familyName: getSingleFilterValue(0),
        husbandName: getSingleFilterValue(1),
        wifeName: getSingleFilterValue(2),
        address: getSingleFilterValue(3),
        city: getSingleFilterValue(4),
        state: getSingleFilterValue(5),
        postalCode: getSingleFilterValue(6),
        phoneNumber: getSingleFilterValue(7),
        email: getSingleFilterValue(8),
    }
    
    const columns = [
        {name : "familyName", label: "Family Name"},
        {name : "husbandName", label: "Husband's Name"},
        {name : "wifeName", label: "Wife's Name"},
        {name : "address", label: "Address"},
        {name : "city", label: "City"},
        {name : "state", label: "State"},
        {name : "postalCode", label: "Zip"},
        {name : "phoneNumbers", label: "Phone" , options: { 
          filterOptions: {
            logic: (phoneNumbers, filters) => {
              const normalizedFilters = filters
                .filter(Boolean)
                .map(filter => String(filter).replace(/\D/g, ""))
                .filter(Boolean)
              return normalizedFilters.length > 0 && !(phoneNumbers || []).some(phone =>
                normalizedFilters.some(filter => phone.phoneNumber && String(phone.phoneNumber).includes(filter))
              )
            }
          },
          customBodyRenderLite: (dataIndex) => {
            const row = households[dataIndex]; 
            return row.phoneNumbers.map(phone => formatPhoneNumber(phone.phoneNumber)).join(", ")
          }
        }},
        {name : "emails", label: "Email" , options: {
          filterOptions: {
            logic: (emails, filters) => {
              const normalizedFilters = filters.filter(Boolean).map(filter => String(filter).toLowerCase())
              return normalizedFilters.length > 0 && !(emails || []).some(email =>
                normalizedFilters.some(filter => email.email && String(email.email).toLowerCase().includes(filter))
              )
            }
          },
          customBodyRenderLite: (dataIndex) => {
            const row = households[dataIndex]; 
            return row.emails ? row.emails.map(email => email.email).join(", ") : ""
          }
        }},
        {name: " ", options: {
            filter: false,
            sort: false,
            empty: true,
            customBodyRenderLite: (dataIndex) => {
              const row = households[dataIndex]; 
              return (
                <div className={helperClasses.floatRight}>
                  <Button variant="contained" size="small" color="success" className={helperClasses.marginLeft} onClick={() => openHousehold(row)}>View</Button>
                </div>
              );
            }
          }
        },
    ]
    const options = {
        filterType: "textField",
        selectableRows: "multiple",
        rowsSelected: selectedHouseholds
          .map(selected => households.findIndex(household => household.id === selected.id))
          .filter(dataIndex => dataIndex >= 0),
        customToolbar: () => {
            return (
                <>
                  {showFilteredCreateButton && <Button variant="contained" size="small" color="success" onClick={() => openCreateHousehold(filterPrefill)}>Create Household</Button>}
                  <AddToolButton handleClick={() => openCreateHousehold()} />
                </>
            );
        },
        customToolbarSelect: () => {
            return (
              <Button
                variant="contained"
                size="small"
                color="warning"
                disabled={selectedHouseholds.length !== 2}
                onClick={openMergeHouseholds}
              >
                Merge selected ({selectedHouseholds.length}/2)
              </Button>
            );
        },
        onRowSelectionChange: (currentRowsSelected, allRowsSelected) => {
          setSelectedHouseholds(allRowsSelected.map(({ dataIndex }) => households[dataIndex]))
        },
        onTableChange: (action, tableState) => {
          if (action === "filterChange") {
            setColumnFilterState({
              filterList: tableState.filterList,
              resultCount: tableState.displayData.length,
            })
          }
        },
        customSearch: matchesHouseholdSearch,
        sortOrder:{name: 'familyName', direction: 'asc'}
    }
    return (
        <>
          {!!isError && <div role="alert">The households could not be loaded.</div>}
          <Grid container spacing={4}>  
            <Grid item xs={12}>
                <MUIDataTable title={"Households Information"} loading={isLoading && !isError} data={households? households : []} columns={columns} options={options} />
            </Grid>
          </Grid>
        </>
      );
}

export default Households
